import { ApiResponse } from '@shared/models';
import { User } from './user';
import { UserDto } from './user.dto';

export class Users {
    items: User[];
    total: number;
    page: number;

    constructor(response: ApiResponse<UserDto[]>) {
        this.items = (response.data ?? []).map((dto) => new User(dto));
        this.total = response.meta?.totalItems ?? 0;
        this.page = response.meta?.currentPage ?? 1;
    }
}
